import {
    GET_NEWSLETTERS,
    GET_CURRENT_NEWSLETTERS,
    DELETE_NEWSLETTER,
    NWL_LOADING,
    ADD_NEWSLETTER,
    UPDATE_NEWSLETTER,
    GET_NEWSLETTER_BY_ID
} from "../actions/NewslettersActions";

const initialState = {
    newsletters: [],
    newsletter: [],
    loading: false,
    success: true,
    addNewsletterItem: null
};

const NewsletterReducer = function(state = initialState, action){
    switch (action.type) {
        case NWL_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case GET_NEWSLETTERS: {
            return {
                ...state,
                newsletters: [...action.data],
                loading: false
            }
        }
        case GET_CURRENT_NEWSLETTERS: {
            return {
                ...state,
                newsletters: [...action.data],
                loading: false
            }
        }
        case GET_NEWSLETTER_BY_ID: {
            return {
                ...state,
                newsletter: [action.data],
                loading: false,
                success: true,
            }
        }
        case ADD_NEWSLETTER: {
            return {
                ...state,
                addNewsletterItem : action.data,
                success: true,
                loading: false
            }
        }
        case UPDATE_NEWSLETTER: {
            return {
                ...state,
                addNewsletterItem : action.data,
                success: true,
                loading: false
            }
        }
        case DELETE_NEWSLETTER: {
            return {
                ...state,
                success: true,
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default NewsletterReducer;


